import * as React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Tooltip } from "@mui/material";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { useNewIgnoreZonesStore } from "./newIgnoreZonesStore/newIgnoreZonesStore";
import { getAssignmentDisplayLabels } from "./utils/assignmentMetricLabels";
import { DeleteIgnoreZoneAssignmentDialog } from "./DeleteIgnoreZoneAssignmentDialog";

const iconButtonSx = {
  minWidth: 0,
  px: "4px",
  py: "2px",
};

const tooltipSx = { fontSize: "12px", fontFamily: "Mulish" };

export const IgnoreZoneAssignmentList = () => {
  const assignments = useNewIgnoreZonesStore((s) => s.assignments);
  const availableMetrics = useNewIgnoreZonesStore((s) => s.availableMetrics);
  const openEditAssignment = useNewIgnoreZonesStore((s) => s.openEditAssignment);
  const openNewAssignment = useNewIgnoreZonesStore((s) => s.openNewAssignment);
  const deleteAssignment = useNewIgnoreZonesStore((s) => s.deleteAssignment);

  const [assignmentToDelete, setAssignmentToDelete] = React.useState<string | null>(
    null
  );

  const visibleAssignments = assignments.filter(
    (assignment) => assignment.coordinates.length > 0
  );

  const handleConfirmDelete = () => {
    if (assignmentToDelete) {
      deleteAssignment(assignmentToDelete);
    }
    setAssignmentToDelete(null);
  };

  return (
    <div className="font-mulish text-actuate-blue">
      <p className="text-[18px] font-bold mb-[16px]">Ignore Zone Assignments</p>
      <div className="flex flex-col gap-[16px] mt-[30px]">
        {visibleAssignments.map((assignment) => {
          const labels = getAssignmentDisplayLabels(assignment, availableMetrics);
          const zoneName = assignment.name || "Zone";
          return (
            <div key={assignment.localId} className="flex gap-[12px]">
              <div className="flex min-w-0 flex-1 gap-[12px]">
                <div
                  className="mt-[6px] size-[18px] shrink-0 border border-actuate-blue"
                  style={{ backgroundColor: assignment.color }}
                />
                <div className="ml-[10px] flex min-w-0 flex-col">
                  <span className="text-[16px] font-bold leading-normal">
                    {zoneName}
                  </span>
                  <span className="text-[16px] leading-normal">
                    {labels.join(", ")}
                  </span>
                </div>
              </div>
              <div className="flex shrink-0 self-start gap-[15px]">
                <Tooltip
                  title={`Edit ${zoneName}`}
                  placement="top"
                  sx={tooltipSx}
                >
                  <div>
                    <OrangeTextButton
                      aria-label={`Edit ${zoneName}`}
                      onClick={() => openEditAssignment(assignment.localId)}
                      text={<EditIcon fontSize="small" />}
                      disabled={false}
                      sx={iconButtonSx}
                    />
                  </div>
                </Tooltip>
                <Tooltip
                  title={`Delete ${zoneName}`}
                  placement="top"
                  sx={tooltipSx}
                >
                  <div>
                    <OrangeTextButton
                      aria-label={`Delete ${zoneName}`}
                      onClick={() => setAssignmentToDelete(assignment.localId)}
                      text={<DeleteIcon fontSize="small" />}
                      disabled={false}
                      sx={iconButtonSx}
                    />
                  </div>
                </Tooltip>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-[28px] ml-[15px]">
        <OrangeTextButton
          onClick={openNewAssignment}
          text="+ Add new ignore zone assignment"
          disabled={false}
        />
      </div>
      <DeleteIgnoreZoneAssignmentDialog
        open={assignmentToDelete !== null}
        onCancel={() => setAssignmentToDelete(null)}
        onConfirm={handleConfirmDelete}
      />
    </div>
  );
};
